import { useContext, useMemo } from "react";

import { useStore } from "@vromo/mobx-react/mobx-react";
import { PageContext } from "../../stores/local/PageStore";
import { RootStore } from "../../stores/RootStore";
import { Platform, platforms, IntegrationProfile } from "@vromo/models/Integration";
import { IntegrationsMap, Setting } from "../../stores/local/IntegrationsStore";
import { IntegrationsApi } from "@vromo/api";
import { runInAction } from "mobx";




/** Most relevant integrations page context */
export const useIntegrationsPage = () => {

    const {
        authStore: { loaded: authLoaded },
        groupStore: { loaded: groupsLoaded },
    } = useStore<RootStore>('rootStore');

    const {
        pageLoading, setLoading,
        fetched, setFetched,
        settings: pageSettings
    } = useContext(PageContext)

    /** current fetched integrations, stored in the FE state */
    const fetchedIntegrations = pageSettings[Setting.integrations] as IntegrationsMap
    const integrationsApi = pageSettings[Setting.api] as IntegrationsApi
    const allPosibleIntegrations = pageSettings[Setting.allPlatforms] as Platform[]


    /** reports if there is any load or query waiting to be completed */
    const isLoading = useMemo(() => {
        return (
            !authLoaded ||
            !groupsLoaded ||
            pageLoading
        )
    }, [authLoaded, groupsLoaded, pageLoading])

    const availableNewIntegrations = useMemo(() => {

        if (fetchedIntegrations.size < 1)
            return allPosibleIntegrations

        const available: Platform[] = []
        allPosibleIntegrations.forEach(platform => !fetchedIntegrations.has(platform) && available.push(platform))
        return available

    }, [fetchedIntegrations, isLoading])


    const updateFetchedIntegrations = (currentIntegrations: IntegrationProfile[]) => {
        // todo: do not destroy existing data ( existing props in existing integrations)
        // update existing data with new fetched data
        runInAction(() => {
            pageSettings[Setting.integrations] = new Map<Platform, IntegrationProfile>(
                currentIntegrations.map(instance => [instance.platform, {
                    ...fetchedIntegrations.get(instance.platform),
                    ...instance,
                    status: undefined,
                    features: {
                        // this is required not to lose the tray wizardurl 
                        ...instance.features,
                        ...fetchedIntegrations.get(instance.platform)?.features
                    }
                }]))
        })
    }



    return {
        // restartContext,
        /** whether websocket data or rest query are being processed */
        isLoading, setLoading,
        /** mobx observable */
        allPosibleIntegrations,
        /** mobx observable */
        fetchedIntegrations,
        updateFetchedIntegrations,
        availableNewIntegrations,
        /** mobx observable */
        integrationsApi,
        fetched, setFetched
    }

}